<template>
    <div class="modal calendar-modal fade" id="mapModal" tabindex="-1" role="dialog" aria-labelledby="mapModal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-if="input_calendar && input_calendar.address" v-html="input_calendar.address"></h5>
                    <h5 class="modal-title" v-else>Galuppi's, 1103 N Federal Hwy, Pompano Beach, FL 33062, USA</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div>
                        <gmap-map
                            ref="googleMap"
                            id="eventMap"
                            :style="`width:100%; height:300px`"
                            :center="mapCenter"
                            :zoom="mapZoom"
                            :options="mapOptions"
                        >
                            <gmap-marker
                                style="height:45px; width:25px;"
                                :icon="marker.icon"
                                :position="{ lat: marker.lat, lng: marker.lng }"
                                :clickable="true"
                                :draggable="false"
                            >
                            </gmap-marker>
                        </gmap-map>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CalendarEventsMapModal",
        props: {
            input_calendar: {
                type: Object,
            },
            input_title: {
                type: String,
            },
            input_coordinates: {
                type: Object,
            }
        },
        data() {
            return {
                mapCenter: this.input_coordinates,
                mapZoom: 4,
                mapOptions: {
                    minZoom: 3,
                    maxZoom: 20,
                    zoomControl: true,
                    panControl: false,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    overviewMapControl: false,
                    rotateControl: false,
                    disableDefaultUI: false,
                    fullscreenControl: false,
                    enableCloseButton: false,
                },
                marker: {},
            }
        },
        methods: {
            centerMapByMarker() {
                this.$refs.googleMap.$mapPromise.then((map) => {
                    const bounds = new google.maps.LatLngBounds();
                    const marker = new google.maps.LatLng(parseInt(this.marker.lat), parseInt(this.marker.lng))

                    bounds.extend(marker);
                    map.fitBounds(bounds);
                });
            },
            setMarkerIcon() {
                this.marker.icon = {
                    url: `/images/marker.png`,
                    scaledSize: { width: 25, height: 40 },
                    labelOrigin: { x: 16, y: -10 }
                };
            }
        },
        watch: {
            input_coordinates: function (newCoords, oldCoords) {
                this.mapCenter = this.marker = newCoords;
                this.centerMapByMarker();
                this.setMarkerIcon();
            }
        }
    }
</script>

<style>
    .gm-style .gm-style-iw {
        overflow: unset !important;
    }
    .gm-style-iw-c {
        padding-left: 0 !important;
        padding-right: 0 !important;
        border-radius: unset !important;
        max-width: 24.375rem !important;
        overflow: unset !important;
        box-shadow: -8px 5px 30px 15px rgba(0,0,0,.28)  !important;
    }
    .gm-style .gm-style-iw-t::after {
        content: none !important;
    }
    .gm-style .gm-style-iw-t::before {
        content: none !important;
    }
    .gm-style-iw-d {
        overflow-x: hidden !important;
        box-shadow: 24px 32px 34px -24px rgba(0,0,0,0.28) !important;
    }
</style>
